import { useOrgContext } from './orgCtx'

export const useCurrentOrg = () => useOrgContext().currentOrg
